import { css } from "@emotion/react";

import theme from "./theme";
import { drawerWidth, grey } from "./variables";

const { spacing } = theme;

export const containerMain = css`
  margin-top: 64px;

  > main {
    padding: ${spacing(3)}px;
    padding-bottom: ${spacing(6)}px;
  }
`;

export const containerLogo = css`
  margin-top: ${spacing(10)}px;
  text-align: center;

  img {
    margin-bottom: ${spacing(5)}px;
  }
`;

export const routes = css`
  margin-left: ${drawerWidth};
`;

export const alert = css`
  margin-bottom: ${spacing(3)}px;

  .MuiAlert-icon {
    display: none;
  }
`;

export const greyAlert = css`
  ${alert}

  background-color: ${grey};
`;

export const group = css`
  margin-top: ${spacing(3)}px;
`;
